import { render, staticRenderFns } from "./ToolbarItem.vue?vue&type=template&id=4d46237d&"
import script from "./ToolbarItem.vue?vue&type=script&lang=js&"
export * from "./ToolbarItem.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarItem.vue?vue&type=style&index=0&id=4d46237d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports